import type { VariantProps } from 'class-variance-authority'
import type { AppConfig } from 'nuxt/schema'
import type { ToastRootProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { cva } from 'class-variance-authority'

export { default as Toast } from './Toast.vue'
export { default as ToastAction } from './ToastAction.vue'
export { default as ToastClose } from './ToastClose.vue'
export { default as ToastDescription } from './ToastDescription.vue'
export { default as Toaster } from './Toaster.vue'
export { default as ToastProvider } from './ToastProvider.vue'
export { default as ToastTitle } from './ToastTitle.vue'
export { default as ToastViewport } from './ToastViewport.vue'
export { toast, useToast } from './use-toast'

export function toastVariants(appConfig: AppConfig) {
  return cva(appConfig.ui.toast.slots.root, {
    variants: appConfig.ui.toast.variants,
    defaultVariants: { ...appConfig.ui.toast.defaultVariants },
  })
}

type ToastVariants = VariantProps<ReturnType<typeof toastVariants>>

export interface ToastProps extends ToastRootProps {
  class?: HTMLAttributes['class']
  variant?: ToastVariants['variant']
  onOpenChange?: ((value: boolean) => void) | undefined
}
